/* Interview Clozo — the ONE app-download helper (owner ruling D20 + addendum; CONTRACT R40, R12 `actions.download`,
   DELTA-BRIEF-SITE item 27; AC-89, S60).
   The DMG is a protected file: no page links a public .dmg. Every former download spot carries
   data-app-download="<placement>" and is BAKED as [Start Free Trial] (D18 label) → the trial checkout in one click
   (checkout.js data-checkout="monthly" data-provider="stripe" data-trial data-entry=…, D17.1). That is what a signed-out
   visitor (or no JS) sees. Signed in, this helper reads R12 (GET /api/billing/summary, one call per page; the account page
   renders its own R12 and hands it over with clozoAppDownload.render(body)) and swaps each spot:
     download.available → Mac: [Download for Mac] = download.url (the private, expiring R40 link; src = install on the
                          install page, else R12's `account`); an expired link re-reads R12 before it is used.
                          Not a Mac: [Email me the Mac link] (RB7).
     not available      → [Start Free Trial] when startTrial.available (D19.1), else [Choose your plan] →
                          /account.html#choose-plan (D17.2). Never a download.
   The private link never sits in storage (only {available, trial} is cached, 60 s, per account). The server records the
   download start (#41, R40); the page sends only #39 account_action_clicked {action:"download"} on the click. */
(function () {
  'use strict';
  var SESSION_KEY = 'interview_session';
  var CACHE_KEY = 'clozo_appdl_v1';
  var TTL = 60 * 1000;
  var L = {
    trial: 'Start Free Trial',
    mac: 'Download for Mac',
    plan: 'Choose your plan',
    macLink: 'Email me the Mac link',
    sent: 'We’ve emailed you the Mac download link. Open it on your Mac.',
    limit: 'We’ve already emailed you the Mac link. Check your inbox on your Mac.',
    fail: 'We couldn’t send it just now. Please try again in a minute.'
  };

  function session() {
    try {
      var s = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
      if (!s || !s.token) return null;
      if (typeof s.expiresAtMillis === 'number' && s.expiresAtMillis > 0 && Date.now() >= s.expiresAtMillis) return null;
      return s;
    } catch (_) { return null; }
  }
  function uid(s) { var u = (s && s.user) || {}; return String(u.id || u.email || u.username || ''); }
  function isMac() {
    var ui = window.clozoBillingUI;
    if (ui && typeof ui.isMac === 'function') { try { return !!ui.isMac(); } catch (_) {} }
    var ua = navigator.userAgent || '';
    return /Macintosh|Mac OS X/.test(ua) && !(navigator.maxTouchPoints > 1);   // an iPad reports "Macintosh" too
  }
  function track(name, props) {
    try { var r = window.__clozoRuntime; if (r && typeof r.track === 'function') r.track(name, props); } catch (_) {}
  }
  function spots(all) {
    var list = Array.prototype.slice.call(document.querySelectorAll('[data-app-download]'));
    return all ? list : list.filter(function (n) { return !n.hasAttribute('data-app-download-host'); });
  }

  /* ---------------- R12 (one GET per page; the link itself is never cached) ---------------- */
  function readCache(s) {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.u === uid(s) && typeof c.at === 'number' && Date.now() - c.at < TTL) return c;
    } catch (_) {}
    return null;
  }
  function writeCache(s, st) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ u: uid(s), at: Date.now(), available: !!st.available, trial: !!st.trial })); } catch (_) {}
  }
  function fetchSummary() {
    var s = session();
    if (!s) return Promise.resolve(null);
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { try { ctl.abort(); } catch (_) {} }, 8000) : null;
    var init = { method: 'GET', headers: { 'Authorization': 'Bearer ' + s.token }, credentials: 'omit', cache: 'no-store' };
    if (ctl) init.signal = ctl.signal;
    return fetch('/api/billing/summary', init).then(function (r) {
      if (timer) clearTimeout(timer);
      if (!r.ok) return null;
      return r.json().catch(function () { return null; });
    }).catch(function () { if (timer) clearTimeout(timer); return null; });
  }
  function stateOf(body) {
    var a = (body && body.actions) || {};
    var d = a.download || {};
    var ok = !!(d.available && typeof d.url === 'string' && /^https:\/\/[^/]+\/download\/app\?t=adl1\./.test(d.url));
    return { available: ok, url: ok ? d.url : null, expiresAtMillis: ok ? d.expiresAtMillis : null,
      trial: !!(a.startTrial && a.startTrial.available) };
  }
  function withSrc(url, placement) {
    // src is analytics only (unsigned); CONTRACT appDownloadSource knows `install` and `account` for R12's link.
    var src = placement === 'install' ? 'install' : 'account';
    try { var u = new URL(url); u.searchParams.set('src', src); return u.toString(); } catch (_) { return url; }
  }

  /* ---------------- render one spot ---------------- */
  var CHECKOUT_ATTRS = ['data-checkout', 'data-provider', 'data-trial', 'data-entry'];
  function stash(n) {
    if (n.__adBaked) return;
    var b = { href: n.getAttribute('href'), label: labelOf(n), attrs: {} };
    CHECKOUT_ATTRS.forEach(function (k) { if (n.hasAttribute(k)) b.attrs[k] = n.getAttribute(k); });
    n.__adBaked = b;
  }
  function labelNode(n) { return n.querySelector('.ad-label') || n; }
  function labelOf(n) { return labelNode(n).textContent; }
  function setLabel(n, text) {
    var ln = labelNode(n);
    if (ln === n) {
      // keep a trailing decorative <span> (the arrow), replace the text before it
      var arrow = n.querySelector('span[aria-hidden], span');
      n.textContent = text;
      if (arrow && arrow.parentNode !== n) { n.appendChild(document.createTextNode(' ')); n.appendChild(arrow); }
    } else ln.textContent = text;
  }
  function status(n) {
    var id = n.getAttribute('data-app-download-status');
    return id ? document.getElementById(id) : null;
  }
  function restoreTrial(n) {
    var b = n.__adBaked;
    CHECKOUT_ATTRS.forEach(function (k) { if (b.attrs[k] != null) n.setAttribute(k, b.attrs[k]); });
    if (!n.hasAttribute('data-checkout')) {
      n.setAttribute('data-checkout', 'monthly'); n.setAttribute('data-provider', 'stripe');
      n.setAttribute('data-trial', ''); n.setAttribute('data-entry', 'page_cta');
    }
    n.setAttribute('href', b.href || '/pricing.html#pricing');
    setLabel(n, L.trial);
    n.setAttribute('data-app-download-state', 'trial');
  }
  function dropCheckout(n) { CHECKOUT_ATTRS.forEach(function (k) { n.removeAttribute(k); }); }

  function render(n, st) {
    stash(n);
    n.hidden = false;
    n.removeAttribute('aria-busy');
    var placement = n.getAttribute('data-app-download') || 'page';
    if (st.available) {
      dropCheckout(n);
      if (isMac()) {
        n.setAttribute('href', /\/download\/app\?/.test(st.url) ? withSrc(st.url, placement) : st.url);
        n.__adExp = st.expiresAtMillis;
        setLabel(n, L.mac);
        n.setAttribute('data-app-download-state', 'mac');
      } else {
        n.setAttribute('href', '#');
        n.setAttribute('role', 'button');
        setLabel(n, L.macLink);
        n.setAttribute('data-app-download-state', 'mac_link');
      }
      return;
    }
    n.removeAttribute('role');
    if (st.trial) { restoreTrial(n); return; }
    dropCheckout(n);
    n.setAttribute('href', '/account.html#choose-plan');
    setLabel(n, L.plan);
    n.setAttribute('data-app-download-state', 'plan');
  }
  function renderAll(st, list) {
    (list || spots(true)).forEach(function (n) {
      render(n, st);
      // A spot whose agreement sentence is its own (the account page's) shows it only with [Start Free Trial].
      var ag = n.getAttribute('data-app-download-agree'), el = ag && document.getElementById(ag);
      if (el) el.hidden = n.getAttribute('data-app-download-state') !== 'trial';
    });
  }

  /* ---------------- clicks ---------------- */
  var last = null;   // the last fresh state (in memory only)
  document.addEventListener('click', function (e) {
    var n = e.target && e.target.closest ? e.target.closest('[data-app-download]') : null;
    if (!n) return;
    var s = n.getAttribute('data-app-download-state');
    if (s === 'mac') {
      track('account_action_clicked', { action: 'download' });
      if (typeof n.__adExp === 'number' && Date.now() >= n.__adExp) {
        // The link expired while the page stayed open: read R12 again and use the fresh one.
        e.preventDefault();
        if (n.getAttribute('aria-busy') === 'true') return;
        n.setAttribute('aria-busy', 'true');
        fetchSummary().then(function (body) {
          var st = stateOf(body); last = st;
          render(n, st);
          if (st.available && isMac()) window.location.assign(n.getAttribute('href'));
        });
      }
      return;
    }
    if (s === 'mac_link') {
      e.preventDefault();
      if (n.getAttribute('aria-busy') === 'true' || n.getAttribute('aria-disabled') === 'true') return;
      var ss = session(); if (!ss) return;
      track('account_action_clicked', { action: 'book_mac_link' });
      n.setAttribute('aria-busy', 'true');
      fetch('/api/book/mac-link', { method: 'POST', headers: { 'Authorization': 'Bearer ' + ss.token, 'Content-Type': 'application/json' },
        body: '{}', credentials: 'omit', cache: 'no-store' })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, ok: r.ok, data: d || {} }; }); })
        .catch(function () { return { status: 0, ok: false, data: {} }; })
        .then(function (r) {
          n.removeAttribute('aria-busy');
          var out = status(n);
          var msg = r.ok ? L.sent : r.status === 429 ? L.limit : ((r.data && typeof r.data.message === 'string' && r.data.message) || L.fail);
          if (r.ok || r.status === 429) { n.setAttribute('aria-disabled', 'true'); n.hidden = true; }
          if (out) { out.textContent = msg; out.hidden = false; }
        });
    }
  }, true);

  /* ---------------- A1-09 (billing v2 WP21): a browser that is not a Mac ----------------
     A phone, a tablet, Windows or Linux sees every [data-mac-handoff] line under Start Free Trial: "Interview Clozo is a Mac
     app" and a mailto: link with which the visitor emails the site's link to themselves (their own mail app writes it; we
     store and send nothing). The affiliate code this browser holds rides along (?via=) so the referral survives the move to
     the Mac. On a Mac the lines stay hidden. */
  function macHandoff() {
    var lines = document.querySelectorAll('[data-mac-handoff]');
    if (!lines.length || isMac()) return;
    var via = null;
    try { var c = window.clozoReferral && typeof window.clozoReferral.codes === 'function' ? window.clozoReferral.codes() : null; via = c && c.last; } catch (_) {}
    Array.prototype.forEach.call(lines, function (n) {
      var a = n.querySelector('a[href^="mailto:"]'), h = a && a.getAttribute('href');
      if (h && typeof via === 'string' && /^[A-Za-z0-9_-]{2,32}$/.test(via) && h.indexOf('%26via%3D') === -1) {
        a.setAttribute('href', h.replace('utm_medium%3Demail', 'utm_medium%3Demail%26via%3D' + via));
      }
      n.hidden = false;
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    macHandoff();
    if (window.__clozoAppDlPending) { var pend = window.__clozoAppDlPending; window.__clozoAppDlPending = null; window.clozoAppDownload.render(pend); }
    var list = spots(false);
    if (!list.length) return;
    var s = session();
    if (!s) return;   // signed out: the baked [Start Free Trial] stays
    var c = readCache(s);
    if (c) {
      // A fresh cached state (≤ 60 s, no link in it): render at once, no call. An eligible Mac visitor gets
      // [Download for Mac] whose click reads R12 for the private link first (the link itself is never stored).
      renderAll({ available: c.available, url: '/account.html#get-app', expiresAtMillis: 0, trial: c.trial }, list);
      return;
    }
    // The footer's spot alone never costs a call (every page carries it — the bare cancellation page must stay
    // call-free, AC-15); it follows the cache when another page has read R12.
    if (!list.some(function (n) { return n.getAttribute('data-app-download') !== 'footer'; })) return;
    fetchSummary().then(function (body) {
      if (!body) return;   // an error keeps the baked [Start Free Trial] (never a download)
      var st = stateOf(body); last = st;
      writeCache(s, st);
      renderAll(st, list);
    });
  }

  window.clozoAppDownload = {
    /* The account page hands over each FRESH R12 body (never the cached paint: the cache holds no link). */
    render: function (body) {
      var st = stateOf(body); last = st;
      var s = session(); if (s) writeCache(s, st);
      renderAll(st, spots(true).filter(function (n) { return n.hasAttribute('data-app-download-host'); }));
    },
    state: function () { return last; },
    isMac: isMac
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
